import { useVariableValue } from '@devcycle/react-client-sdk';
import { clsx } from 'clsx';
import { FC, useContext } from 'react';

import { FOOTER, HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { Button } from '../Button';
import { CMSProviderContext, NavItemData } from '../services/content';

import { MegaNav } from './MegaNav';
import styles from './Navigation.module.scss';

export interface NavigationProps {
  variant: 'footer' | 'header';
}

export const Navigation: FC<NavigationProps> = ({ variant }) => {
  const { footer, header } = useContext(CMSProviderContext);
  const megaNavFlag = useVariableValue('mega-nav', false);

  if (variant == HEADER) {
    return (
      <nav className={clsx(styles.headerNavigation, styles.displayOnDesktop)} data-testid="header-navigation">
        <ul className={styles.ul}>
          {header.data.nav.map((nav) => (
            <li key={nav.label}>
              {megaNavFlag ? (
                <MegaNav nav={nav} />
              ) : (
                <Button
                  href={nav.link.href}
                  size="md"
                  emphasis="quaternary"
                  styleVariant="neutral"
                  onPress={() => pushGTMEvent(nav.label, nav.label, '1')}
                >
                  {nav.label}
                </Button>
              )}
            </li>
          ))}
        </ul>
      </nav>
    );
  } else if (variant == FOOTER) {
    return (
      <nav className={styles.footerNavigation} data-testid="footer-navigation">
        <ul className={styles.ul}>
          {footer.data.links.map(({ label, url }: NavItemData) => (
            <li key={label} className={styles.navigationLink}>
              <Button styleVariant="accent" emphasis="primary" size="md" href={url} onPress={() => pushGTMEvent(FOOTER, label)}>
                {label}
              </Button>
            </li>
          ))}
        </ul>
      </nav>
    );
  }
};
